import React from 'react';
import { Menu } from 'lucide-react';

import { FC_TRANSFER_DIRECTION } from 'components/warehouse/components/fcTransfers/FCTransferFilterConfig';
import { Button } from 'shadcn/components/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from 'shadcn/components/ui/DropdownMenu';

/**
 * Overflow menu for FC Transfer list rows. Outbound vs Inbound sets differ (tech spec §6.1).
 *
 * @param {Object} props
 * @param {'OUTBOUND' | 'INBOUND'} props.direction
 * @param {boolean} [props.isEditTransferDisabled=false] — `Edit Transfer` only when status is `PENDING`.
 * @param {() => void} [props.onEditTransfer]
 * @param {() => void} [props.onDownloadBol]
 * @param {() => void} [props.onCancelTransfer]
 * @param {() => void} [props.onAccept]
 */
export function FCTransferActionsMenu({
    direction = FC_TRANSFER_DIRECTION.OUTBOUND,
    isEditTransferDisabled = false,
    onAccept = () => {},
    onCancelTransfer = () => {},
    onDownloadBol = () => {},
    onEditTransfer = () => {},
}) {
    const isInbound = direction === FC_TRANSFER_DIRECTION.INBOUND;

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button type="button" variant="ghost" size="icon" aria-label="Open actions menu">
                    <Menu className="h-4 w-4" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
                {isInbound ? (
                    <>
                        <DropdownMenuItem onSelect={onAccept}>Accept</DropdownMenuItem>
                        <DropdownMenuItem onSelect={onDownloadBol}>Download BOL</DropdownMenuItem>
                    </>
                ) : (
                    <>
                        <DropdownMenuItem onSelect={onEditTransfer} disabled={isEditTransferDisabled}>
                            Edit Transfer
                        </DropdownMenuItem>
                        <DropdownMenuItem onSelect={onDownloadBol}>Download BOL</DropdownMenuItem>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem variant="destructive" onSelect={onCancelTransfer}>
                            Cancel Transfer
                        </DropdownMenuItem>
                    </>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}

FCTransferActionsMenu.displayName = 'FCTransferActionsMenu';
